
import { getTemplateOperationsForProducts } from '@/utils/profiles/templates';
import { applyOperationToProduct } from '@/utils/edit/operations';
import { setProductErrors } from '@/utils/product/errors';
import { getSize } from '@/utils/iterable/getSize';

import { SECTIONS, PROFILE_TYPE } from '@/constants/profiles';
import { ATTRIBUTE } from '@/constants/attributes';
import { ERROR } from '@/constants/product';
import { FORM } from '@/constants/forms';

export function applyProfile({
  product: source,
  profile,
  shop,
  shopData,
  template,
  type,
  userFeatures,
}) {
  const channel = source.get('channel');

  function reduceAiForms(result, form) {
    if (!profile.getIn(['sections', form])) return result;

    switch (form) {
      case FORM.DESCRIPTION: {
        result.product = result.product.setIn([FORM.DESCRIPTION, 'ai'],
          profile.getIn(['ai', ATTRIBUTE.DESCRIPTION]).set('profile', true)
        );

        break;
      }

      case FORM.SEO: {
        result.product = result.product
          .setIn([FORM.SEO, 'ai', ATTRIBUTE.META_DESCRIPTION],
            profile.getIn(['ai', ATTRIBUTE.META_DESCRIPTION]).set('profile', true)
          )
          .setIn([FORM.SEO, 'ai', ATTRIBUTE.PAGE_TITLE],
            profile.getIn(['ai', ATTRIBUTE.PAGE_TITLE]).set('profile', true)
          );

        break;
      }
      case FORM.TAGS: {
        result.product = result.product.setIn([FORM.TAGS, 'ai'],
          profile.getIn(['ai', ATTRIBUTE.TAGS]).set('profile', true)
        );

        break;
      }

      case FORM.TITLE: {
        result.product = result.product.setIn([FORM.TITLE, 'ai'],
          profile.getIn(['ai', ATTRIBUTE.TITLE]).set('profile', true)
        );

        break;
      }

      default: {
        break;
      }
    }

    return result;
  }

  function reduceTemplateOperations(result, operation) {
    return applyOperationToProduct({
      operation,
      shop,
      shopData,
      userFeatures,
      ...result,
    });
  }

  switch (type) {
    case PROFILE_TYPE.AI: {
      return SECTIONS[channel][type].reduce(reduceAiForms, { product: source });
    }

    case PROFILE_TYPE.STANDARD: {
      const operations = getTemplateOperationsForProducts({
        channel,
        profile: profile.set('template', template),
        userFeatures,
      });

      if (getSize(operations) === 0) {
        return { product: source };
      }

      const { confirmation, product } = operations.reduce(reduceTemplateOperations, { product: source });

      return {
        confirmation,
        product: product.has(ERROR)
          ? setProductErrors({ product, shop, shopData, userFeatures })
          : product,
      };
    }

    default: {
      return { product: source };
    }
  }
}
